(function () {
  'use strict';

  var states = new Map();
  var sliders = new Map();
  var pending = new Set();
  var frame = null;
  var motions = new Map();

  function flush() {
    frame = null;
    var measurements = [];
    pending.forEach(function (state) {
      if (!state.component.isConnected || !state.visible) return;
      var width = state.slider.scrollWidth;
      var visibleWidth = state.slider.clientWidth;
      var max = width - visibleWidth;
      var progress = max > 2 ? Math.max(0, Math.min(1, state.slider.scrollLeft / max)) : 0;
      measurements.push({ state: state, progress: progress, thumb: Math.min(1, visibleWidth / Math.max(1, width)), max: max });
    });
    pending.clear();
    measurements.forEach(function (item) {
      var state = item.state;
      var progress = item.progress.toFixed(4);
      var thumb = item.thumb.toFixed(4);
      if (state.progress !== progress) {
        state.component.style.setProperty('--silver-progress', progress);
        state.progress = progress;
      }
      if (state.thumb !== thumb) {
        state.component.style.setProperty('--silver-thumb', thumb);
        state.thumb = thumb;
      }
      state.component.toggleAttribute('data-silver-start', item.progress <= 0.01);
      state.component.toggleAttribute('data-silver-end', item.progress >= 0.99 || item.max <= 2);
    });
  }

  function queue(state) {
    if (!state || !state.visible) return;
    pending.add(state);
    if (frame === null) frame = window.requestAnimationFrame(flush);
  }

  var visibility = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      queue(state);
    });
  }, { rootMargin: '100px' });

  var resize = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { queue(sliders.get(entry.target)); });
  });

  function setMotion(element, visible) {
    element.style.setProperty('--silver-motion-state', visible && !document.hidden ? 'running' : 'paused');
  }

  var motionVisibility = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      motions.set(entry.target, entry.isIntersecting);
      setMotion(entry.target, entry.isIntersecting);
    });
  });

  function setup(component) {
    var buttons = component.querySelector('.slider-buttons');
    var slider = component.querySelector('.slider');
    if (!buttons || !slider || states.has(component)) return;
    if (buttons.classList.contains('slideshow__controls')) return;

    var bar = document.createElement('div');
    bar.className = 'silver-slider-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.appendChild(document.createElement('span'));
    var counter = buttons.querySelector('.slider-counter');
    buttons.insertBefore(bar, counter || buttons.lastElementChild);
    buttons.setAttribute('data-silver-ready', '');
    component.setAttribute('data-silver-ready', '');

    var state = { component: component, slider: slider, visible: false };
    states.set(component, state);
    sliders.set(slider, state);
    slider.addEventListener('scroll', function () { queue(state); }, { passive: true });
    visibility.observe(component);
    resize.observe(slider);
  }

  function init() {
    states.forEach(function (state, component) {
      if (component.isConnected) return;
      visibility.unobserve(component);
      resize.unobserve(state.slider);
      sliders.delete(state.slider);
      states.delete(component);
      pending.delete(state);
    });
    motions.forEach(function (visible, element) {
      if (element.isConnected) return;
      motionVisibility.unobserve(element);
      motions.delete(element);
    });
    var main = document.getElementById('MainContent') || document;
    main.querySelectorAll('slider-component').forEach(setup);
    main.querySelectorAll('[data-silver-hero], .silver-brands').forEach(function (element) {
      if (motions.has(element)) return;
      motions.set(element, true);
      motionVisibility.observe(element);
    });
  }

  window.addEventListener('load', function () { states.forEach(queue); }, { once: true });
  document.addEventListener('visibilitychange', function () { motions.forEach(function (visible, element) { setMotion(element, visible); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
